<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">
        Cohort 2 Compound Enrollment
      </h2>
      <p class="tw-italic tw-text-gray-700">
        
      </p>
    </b-container>


    <b-container>
      <b-row>
      <b-col class="text-right"><h4>Cluster:</h4></b-col>
      <b-col class="text-left"><b-select :options="clusters" v-model="selected_cluster" @change="get_compounds" style="width: 300px;"></b-select></b-col>
    </b-row>
    <b-row class="tw-p-5">
      <b-col>
        <h4 class="text-center" v-if="STUDY == 'kenya'">CORE</h4>
         <div>
           <b-table striped hover :items="core" :fields="fields" style="max-height: 400px !important; overflow: auto; overflow-x: hidden;">
              <template v-slot:cell(status)="data" v-if="STUDY == 'kenya'">
                <!-- <i class="fa fa-ellipsis-h" style="color: #6c757d;" v-if="data.item.status == 'queued'" title="Compound Queued - Not in CommCare"></i> -->
                <b-button class="push-now btn-success btn-sm" @click="push_directly(data.item)" v-if="data.item.status == 'queued'"><i class="fa fa-arrow-up"></i> CommCare</b-button>
                <i class="fa fa-clock" style="color: #6c757d;" v-if="data.item.status == 'sent'" title="Visitation Pending - Sent to CommCare"></i>
                <i class="fa fa-check text-success" v-if="data.item.status == 'complete'" title="Visit Completed"></i>
                <i class="fa fa-user-times text-danger" v-if="data.item.status == 'omitted'" title="Removed due to lack of subjects"></i>
                <i class="fa fa-lightbulb text-danger" v-if="data.item.status == 'lt-enrolled'" title="Compound enrolled in Light Trap"></i>
              </template>
            </b-table>
         </div>
      </b-col>

      <b-col v-if="STUDY == 'kenya'">
        <h4 class="text-center">BUFFER</h4>
        <div>
            <b-table striped hover :items="buffer" :fields="fields" style="max-height: 400px !important; overflow: auto; overflow-x: hidden;">
            <template v-slot:cell(status)="data">
                <!-- <i class="fa fa-ellipsis-h" style="color: #6c757d;" v-if="data.item.status == 'queued'" title="Compound Queued - Not in CommCare"></i> -->
                <b-button class="push-now btn-success btn-sm" @click="push_directly(data.item)" v-if="data.item.status == 'queued'"><i class="fa fa-arrow-up"></i> CommCare</b-button>
                <i class="fa fa-clock" style="color: #6c757d;" v-if="data.item.status == 'sent'" title="Visitation Pending - Sent to CommCare"></i>
              <i class="fa fa-check text-success" v-if="data.item.status == 'complete'" title="Visit Completed"></i>
              <i class="fa fa-user-times text-danger" v-if="data.item.status == 'omitted'" title="Removed due to lack of subjects"></i>
                <i class="fa fa-lightbulb text-danger" v-if="data.item.status == 'lt-enrolled'" title="Compound enrolled in Light Trap"></i>
            </template>
          </b-table>
        </div>
      </b-col>
    </b-row>
    <b-row class="tw-p-5">
      <b-col>
        <div>
          <b-card header-tag="nav">
            <b-card-text class="text-center">
              <h4 class="tw-font-bolder tw-mb-0 text-center">Core Enrollment Status</h4>
              <!-- <p class="text-secondary tw-text-xs text-center">Subheader for single number, if needed</p>
              <h1
                class="tw-text-5xl tw-font-bolder text-center tw-mb-0"
              >{{raw}}</h1> -->

              <b-container>
                <b-row class="justify-content-center">
                  <b-col cols="auto" class="text-center">
                    <h1 class="tw-text-4xl tw-font-bolder">
                      {{ core_removed }}
                    </h1>
                    <span>Removed</span>
                  </b-col>
                  <b-col cols="auto" class="text-center" v-b-modal.enrolled_core_modal>
                    <h1 class="tw-text-6xl tw-font-bolder">
                      {{ core_enrolled.length }}
                    </h1>
                    <span class="tw-text-2xl">Enrolled</span>
                  </b-col>
                  <b-col cols="auto" class="text-center">
                    <h1 class="tw-text-4xl tw-font-bolder">
                      {{ core_pending }}
                    </h1>
                    <span>Remaining</span>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-text>
          </b-card>
         </div>
      </b-col>
      <b-col>
        <div>
          <b-card header-tag="nav">
            <b-card-text class="text-center">
              <h4 class="tw-font-bolder tw-mb-0 text-center">Buffer Enrollment Status</h4>
              <!-- <p class="text-secondary tw-text-xs text-center">Subheader for single number, if needed</p>
              <h1
                class="tw-text-5xl tw-font-bolder text-center tw-mb-0"
              >{{raw}}</h1> -->

              <b-container>
                <b-row class="justify-content-center">
                  <b-col cols="auto" class="text-center">
                    <h1 class="tw-text-4xl tw-font-bolder">
                      {{ buffer_removed }}
                    </h1>
                    <span>Removed</span>
                  </b-col>
                  <b-col cols="auto" class="text-center" v-b-modal.enrolled_buffer_modal>
                    <h1 class="tw-text-6xl tw-font-bolder">
                      {{ buffer_enrolled.length }}
                    </h1>
                    <span class="tw-text-2xl">Enrolled</span>
                  </b-col>
                  <b-col cols="auto" class="text-center">
                    <h1 class="tw-text-4xl tw-font-bolder">
                      {{ buffer_pending }}
                    </h1>
                    <span>Remaining</span>
                  </b-col>
                </b-row>
              </b-container>
            </b-card-text>
          </b-card>
         </div>
      </b-col>
    </b-row>
    </b-container>
    

    <b-modal id="enrolled_core_modal" title="Enrolled Compounds in CORE" ok-only>
      <span class="font-italic" v-if="core_enrolled.length == 0">No compounds have been enrolled yet.</span>
      <b-table striped hover borderless v-if="core_enrolled.length > 0" :items="core_enrolled" :fields="modal_fields">
             
      </b-table>
    </b-modal>

    <b-modal id="enrolled_buffer_modal" title="Enrolled Compounds in BUFFER" ok-only>
      <span class="font-italic" v-if="buffer_enrolled.length == 0">No compounds have been enrolled yet.</span>
      <b-table striped hover borderless v-if="buffer_enrolled.length > 0" :items="buffer_enrolled" :fields="modal_fields">
             
      </b-table>
    </b-modal>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
     clusters: [],
     selected_cluster: null,
     core: [],
     core_removed: 0,
     core_enrolled: 0,
     core_pending: 0,
     buffer_removed: 0,
     buffer_enrolled: 0,
     buffer_pending: 0,
     buffer: [],
     fields: [
       { key: 'order', label: 'Order'},
       { key: 'compound_id', label: 'Compound', class: 'text-right' },
       { key: 'status', label: 'Status', class: 'text-center'}
     ],
     modal_fields: [
       { key: 'order', label: 'Order'},
       { key: 'compound_id', label: 'Compound', class: 'text-right' }
     ]
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/compounds/get_clusters").then(response => {
      for(var i = 0; i < response.data.length; i++){
        that.clusters.push({
          value: response.data[i].cluster,
          text: response.data[i].cluster + ' - ' + response.data[i].villages
        })
      }
      that.selected_cluster = that.clusters[0].value;
      that.get_compounds();
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
    push_directly: function(data){
      const fd = new FormData();
      fd.append('case_id', data.case_id);
      let record = data;
      HTTP.post('/kenya/compounds/push_baseline', fd).then((response) => {
        record.status = 'sent';
      }).catch(error => {
            alert("Failed to push compound.");
      });

    },
    get_compounds: function(){
      let that = this;
      that.core = [];
      that.buffer = [];
      that.core_removed = 0;
      that.core_enrolled = [];
      that.core_pending = 0;
      that.buffer_removed = 0;
      that.buffer_enrolled = [];
      that.buffer_pending = 0;
      HTTP.get("/kenya/compounds/get_compounds/"+that.selected_cluster+"/").then(response => {
          for(var i = 0; i < response.data.length; i++){
            if(that.STUDY == 'kenya'){
              if(response.data[i].status == 'lt-enrolled'){
                console.log(response.data[i]);
              }
              if(response.data[i].core_or_buffer.toLowerCase() == 'core'){
                that.core.push(response.data[i]);
                if(response.data[i].status == 'pending'){
                  that.core_pending += 1;
                }
                if(response.data[i].status == 'complete'){
                  that.core_enrolled.push(response.data[i]);
                }
                if(response.data[i].status == 'omitted' || response.data[i].status == 'lt-enrolled'){
                  that.core_removed += 1;
                }
              }
              if(response.data[i].core_or_buffer.toLowerCase() == 'buffer' ){
                that.buffer.push(response.data[i]);
                if(response.data[i].status == 'pending'){
                  that.buffer_pending += 1;
                }
                if(response.data[i].status == 'complete'){
                  that.buffer_enrolled.push(response.data[i]);
                }
                if(response.data[i].status == 'omitted' || response.data[i].status == 'lt-enrolled'){
                  that.buffer_removed += 1;
                }
              }
            }
            if(that.STUDY == 'mali'){
              that.core.push(response.data[i]);
            }
          }
      });
    }
  }
};
</script>

<style>
.push-now{
  font-size: 12px;
}
</style>